import { Schema } from "nutso";

import { Member } from "../models/Member";

export const memberSchema: Schema<Member, any, any> = {
  type: "object",
  properties: {
    uid: {
      type: "string",
    },
    emailAddress: {
      type: "string",
    },
    orgId: {
      type: "string",
    },
    createdByUid: {
      type: "string",
    },
    createdIsoDateTimeUtc: {
      type: "string",
    },
    updatedIsoDateTimeUtc: {
      type: "string",
    },
    secondaryEmailAddress: {
      type: "string",
      optional: true,
    },
    role: {
      type: "string",
    },
    randomPassword: {
      type: "string",
      optional: true,
    },
    shouldUpdatePasswordOnLogin: {
      type: "boolean",
      optional: true,
    },
    firstName: {
      type: "string",
    },
    lastName: {
      type: "string",
    },
    profilePicture: {
      type: "object",
      optional: true,
      properties: {
        id: {
          type: "string",
        },
        path: {
          type: "string",
        },
      },
    },
    aliasEmailAddresses: {
      type: "array",
      optional: true,
      items: {
        type: "string",
      },
    },
  },
};
